import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import CashBank from "../../../containers/modules/accounting/cash-bank";

export default function CashBankRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="cash-bank"
      index
      element={
        <AccessControl
          name={"Cash Bank Create"}
          auth={authUser}
          component={() => <CashBank />}
        />
      }
    />
  );
}
